import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "plan",
    serviceName: "auth",
    query: gql`
      query plan($ids: [String]) {
        plan(ids: $ids) {
          data {
            title
            amount
            related_to
            validity_months
            lab_quantity
            unit_quantity
            doctor_quantity
            details
          }
        }
      }
    `,
  },
  update: {
    name: "updatePlan",
    serviceName: "admin",
    query: gql`
      mutation updatePlan(
        $ids: [String]!
        $title: String
        $validity_months: String
        # $quantity: String
        # $order_quantity: String
        $lab_quantity: String
        $unit_quantity: String
        $doctor_quantity: String
        # $agreement_quantity: String
        $amount: String
        $code: String
        $details: String
        $related_to: String # labratoar < ,unit
      ) {
        updatePlan(
          ids: $ids
          title: $title
          validity_months: $validity_months
          # quantity: $quantity
          # order_quantity: $order_quantity
          lab_quantity: $lab_quantity
          unit_quantity: $unit_quantity
          doctor_quantity: $doctor_quantity
          # agreement_quantity: $agreement_quantity
          amount: $amount
          code: $code
          details: $details
          related_to: $related_to
        ) {
          messages
          influenced_count
        }
      }
    `,
  },
};

export default schema;
